module.exports = __webpack_public_path__ + "img/home-07-cosmopolitan-sample-04-street-04.8758b372.jpg";